import { render } from "./dialogDrag.vue?vue&type=template&id=0a49efae"
import script from "./dialogDrag.vue?vue&type=script&lang=js"
export * from "./dialogDrag.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/drag/dialogDrag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a49efae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a49efae', __exports__)) {
    console.log('reload')
    api.reload('0a49efae', __exports__)
  }
  
  module.hot.accept("./dialogDrag.vue?vue&type=template&id=0a49efae", () => {
    console.log('re-render')
    api.rerender('0a49efae', render)
  })

}


export default __exports__